import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { fetchKeywordSuggestions } from "./thunks";
import { KeywordSuggestionsState } from "./types";

const initialState: KeywordSuggestionsState = {
  suggestions: [],
  loading: false,
  error: null,
  lastSearched: null,
};

const keywordSuggestionsSlice = createSlice({
  name: "keywordSuggestions",
  initialState,
  reducers: {
    clearSuggestions: (state) => {
      state.suggestions = [];
      state.error = null;
      state.lastSearched = null;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchKeywordSuggestions.pending, (state, action) => {
        state.loading = true;
        state.error = null;
        state.lastSearched = action.meta.arg.keyword;
      })
      .addCase(fetchKeywordSuggestions.fulfilled, (state, action) => {
        state.loading = false;
        state.suggestions = action.payload;
        state.error = null;
      })
      .addCase(fetchKeywordSuggestions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch keyword suggestions";
        state.suggestions = [];
      });
  },
});

export const { clearSuggestions, clearError } = keywordSuggestionsSlice.actions;

export default keywordSuggestionsSlice.reducer;